/**
 * Collection file for languages
 * Be aware that vue-i18n warnings refer only to the reference, not to where it is being used!
 * this means that if messages.header.title does NOT guarantee the warning comes from header.
 * Source: https://kazupon.github.io/vue-i18n/introduction.html
 */

 // Languages
import enUS from '@assets/internationalization/languages/en-US.json'
import frFR from '@assets/internationalization/languages/fr-FR.json'
import itIT from '@assets/internationalization/languages/it-IT.json'
import enLX from '@assets/internationalization/languages/en-LX.json'

// NOTE: defaultLocale is also used as fallbackLocale
export const defaultLocale = 'en-US'

// Defines for languages
let languages = {
  'en-US': enUS,
  'fr-FR': frFR,
  'it-IT': itIT,
  'en-LX': enLX
}

/**
 * Used to test if all fields have been made translation ready.
 * Copies en-US (enUS) and replaces all values with 'xxxx'.
 */
const debug = process.env.NODE_ENV === 'development' // easy flag for use
if(debug) {
  console.warn('BEWARE: internationalization debug mode ON - development mode only.')
  let test = JSON.stringify(enUS)
    .replace(/(?::")(.*?)(?:")/g, ':"xxxx"')
    .replace(/(?:"icon":)(?:.*?)(?:")(.*?)(?:")/g, '"icon": "xxxx.png"')
    .replace(/(?:"foil":)(?:.*?)(?:")(.*?)(?:")/g, '"foil": "xxxx.jpg"')
    .replace(/(?:"hotspots":)(?:.*?)(?:")(.*?)(?:")/g, '"hotspots": "xxxx.svg"')
  test = JSON.parse(test)
  test.localeInformation.name = test.localeInformation.locale = 'test'
  languages.test = test
}

export {languages}
// locale overview
export const localeOverview = Object.keys(languages).map(language => languages[language].localeInformation)

export const changeFavIcon = (href) => {
  var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
  link.type = 'image/png'
  link.rel = 'shortcut icon'
  link.href = href
  document.getElementsByTagName('head')[0].appendChild(link)
}